import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/Compoents/header/header.component';
import { CommunicateService } from './core/Services/communicate.service';
import { NgxUiLoaderModule, NgxUiLoaderService } from 'ngx-ui-loader';
import { SwUpdate } from '@angular/service-worker';
import { ApmService } from './core/Services/apmService.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, HeaderComponent, NgxUiLoaderModule], providers: [DatePipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'signpl-advanced';
  constructor(public CMService: CommunicateService, private loader: NgxUiLoaderService
    , private readonly swUpdate: SwUpdate, private apmservice: ApmService

  ) {
    // this.apmservice.apm.setUserContext({ id: 'anonymous' });
  }

  ngOnInit() {
    this.CMService.isLoaderLoad.subscribe((res: any) => {
      if (res === true) {
        this.loader.start();
      } else {
        this.loader.stopAll();
      }
    })
    this.swUpdate?.checkForUpdate().then((val) => {
      if (val) {
        if (confirm("A new update is available. Would you like to update now?")) {
          window.location.reload();
        }
      }
    });
  }
}
